













































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import SuporteSalasCentrosCirurgicosStore from '@/components/Suporte/Store/SuporteSalasCentrosCirurgicosStore'

@Component
export default class ComponentModalSuporteCentroCirurgico extends Vue {
  loadSaveOrUpdateCentroCirurgico: boolean = false

  get getSuporteSalasCentrosCirurgicosStore() {
    return getModule(SuporteSalasCentrosCirurgicosStore, this.$store)
  }

  get loadingSaveOrUpdateCentroCirurgico() {
    return this.loadSaveOrUpdateCentroCirurgico
  }

  set loadingSaveOrUpdateCentroCirurgico(value: boolean) {
    this.loadSaveOrUpdateCentroCirurgico = value
  }

  get showModalCentroCirurgico() {
    return this.getSuporteSalasCentrosCirurgicosStore.modal.centroCirurgico
  }

  set showModalCentroCirurgico(value: boolean) {
    this.getSuporteSalasCentrosCirurgicosStore.setModal({ name: 'centroCirurgico', value })
  }

  $refs!: {
    formCentroCirurgico: any
  }

  formCentroCirurgicoRules: any = {
    valid: true,
    nome: [(v: any) => !!v || 'Campo obrigatório.'],
    status: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  async saveOrUpdateCentroCirurgico() {
    this.loadingSaveOrUpdateCentroCirurgico = true

    if (this.$refs.formCentroCirurgico.validate()) {
      const { mode } = this.getSuporteSalasCentrosCirurgicosStore

      const response = await this.getSuporteSalasCentrosCirurgicosStore.upsertCentroCirurgico()

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Centro cirúrgico ${mode === 'CREATE' ? 'criado' : 'alterado'} com sucesso! ${String.fromCodePoint(0x1F642)}`,
          icon: 'done',
          color: '#2E7D32',
        })

        await this.getSuporteSalasCentrosCirurgicosStore.getCentrosCirurgicosPagedSearch(this.getSuporteSalasCentrosCirurgicosStore.paginationCentrosCirurgicos)
        this.showModalCentroCirurgico = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao ${mode === 'CREATE' ? 'criar' : 'alterar'} o centro cirúrgico ${String.fromCodePoint(0x1F615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdateCentroCirurgico = false
  }

  @Watch('showModalCentroCirurgico')
  onChangeshowModalCentroCirurgico(value: boolean) {
    if (!value) {
      this.getSuporteSalasCentrosCirurgicosStore.clearCentroCirurgico()
      this.getSuporteSalasCentrosCirurgicosStore.setMode({ mode: 'CREATE' })
      this.$refs.formCentroCirurgico.resetValidation()
    }
  }
}
